import React, { ReactElement, Component, useContext } from 'react';
import { LeftMenuTitleContext } from '../../contexts/left-menu-title';
import { Col, Row } from 'antd';
import { item } from '../../contexts/items';
import { WorkSpaceSelectedContext } from '../../contexts/workspace-selected';

export const AlertManagement: React.FC = (): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
    const workspace_selected: item | undefined | undefined = useContext(WorkSpaceSelectedContext)[0];
    const left_menu_title: string = useContext(LeftMenuTitleContext)[0];
    return (
        <Col className="px-20" sm={20} offset={2}>
            <Row className="card global box_rounded">
                <div className="card_title">{workspace_selected?.name}</div>
                <Col lg={10}>
                </Col>
            </Row>
            <Row className="card global box_rounded">
                <div className="card_title">{left_menu_title} Alerts</div>
                <Row justify="center">You don't have any alerts for now.</Row>
            </Row>
        </Col>
    )
}